module.exports = __webpack_public_path__ + "img/user-placeholder.d6884939.png";